export default {
  ENABLE_SENTRY: false,
};
